// CardDetails.js
import React from "react";
import { IoIosCloseCircleOutline } from "react-icons/io";
import parse from "html-react-parser";

function CardDetails({ staff, onClose }) {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
      <div className="relative bg-white p-8 rounded-lg shadow-lg max-w-3xl w-full flex flex-col md:flex-row overflow-hidden"> {/* flex-col on small screens */}
        {/* Close Button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 text-4xl text-gray-500 hover:text-black"
        >
          <IoIosCloseCircleOutline />
        </button>

        {/* Content Section */}
        <div className="flex flex-col md:flex-row space-x-0 md:space-x-6 w-full"> {/* flex-col on small screens */}
          {/* Image */}
          <div className="w-full md:w-1/3 h-64 flex-shrink-0"> {/* full width on small screens */}
            <img
              src={staff.staff_image_url}
              alt={staff.staff_name}
              className="rounded-lg w-full h-full object-contain"
              style={{ objectFit: 'contain' }}
            />
          </div>

          {/* Text Content */}
          <div className="w-full md:w-2/3 overflow-y-auto"> {/* full width on small screens, scrollable */}
            <h2 className="text-3xl font-bold mb-4 font-titillium">{staff.staff_name}</h2>
            <p className="text-lg font-semibold mb-2 text-primary-color font-inter">
              {staff.staff_designation}
            </p>
            <p className="text-sm text-gray-600 mb-4 font-inter">{staff.department_name}</p>
            <div
              className="text-gray-700 text-base leading-relaxed"
              style={{ maxHeight: "200px" }} // Adjust the height as needed
            >
              {parse(staff.staff_qualifications)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CardDetails;